import React from 'react';
import { SnackbarProvider } from 'notistack';
import { PropTypes } from 'prop-types';

const NotificationProvider = props => {
  return (
    <SnackbarProvider maxSnack={props.maxSnackbars}>
      {props.children}
    </SnackbarProvider>
  );
};

NotificationProvider.propTypes = {
  maxSnackbars: PropTypes.number,
};

export default NotificationProvider;
